import { render, staticRenderFns } from "./CPAlertsSummary.vue?vue&type=template&id=ad15bf1e&scoped=true&"
import script from "./CPAlertsSummary.vue?vue&type=script&lang=ts&"
export * from "./CPAlertsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CPAlertsSummary.vue?vue&type=style&index=0&id=ad15bf1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad15bf1e",
  null
  
)

export default component.exports